import React, { useState, useEffect } from "react";
import { convertSecondsToDuration } from './../utils';

export default function Timer({ targetTime, targetReached }) {
  const [time, setTime] = useState(0)

  useEffect(() => {
    if (targetReached && targetTime > 0) {
      const interval = setInterval(() => setTime(targetTime - Math.floor(Date.now() / 1000)), 1000)
      return () => { clearInterval(interval) }
    }
    else {
      setTime(0)
    }
  }, [targetTime, targetReached])

  return (
    <span>
      {time > 0 ? convertSecondsToDuration(time) : "--"}
    </span>
  );
}